import SvgIcon from '../../utils/Icon';
import { ReactComponent as Web } from '../../assets/icons/web.svg';
import { alertaGeneral } from '../../utils/alertas';
import { enriquecerAliado } from './aliadosContenido';

const AliadoFicha = ({ aliado }) => {
  const ficha = enriquecerAliado(aliado);

  const avisarPagoPendiente = () => {
    alertaGeneral({
      titulo: 'Pago próximamente',
      messageHtml: 'El botón de pago está pendiente por parte de REDPLIKA.',
      isInfo: true,
    });
  };

  return (
    <article className="bg-white rounded-2xl shadow-md border border-gray-200 p-5 flex flex-col h-full">
      <div className="w-28 h-28 mx-auto mb-4 bg-gray-50 rounded-xl flex items-center justify-center p-3">
        {ficha.logo ? (
          <img
            src={ficha.logo}
            alt={ficha.nombre}
            className="max-w-full max-h-full object-contain"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        ) : (
          <span className="text-sm font-semibold text-gray-400 text-center">{ficha.nombre}</span>
        )}
      </div>
      <h3 className="text-lg font-bold text-gray-800 text-center">{ficha.nombre}</h3>
      {ficha.etiqueta && (
        <p className="mt-2 mx-auto w-fit text-xs font-semibold text-[#1f94c2] bg-blue-50 px-3 py-1 rounded-full">
          {ficha.etiqueta}
        </p>
      )}
      <p className="text-sm text-gray-600 text-center mt-3 leading-relaxed flex-1">{ficha.descripcion}</p>
      <div className="mt-4 space-y-2 text-sm text-center">
        {ficha.telefono && (
          <a href={`tel:${ficha.telefono}`} className="block text-[#205087] font-medium">
            Tel: {ficha.telefono}
          </a>
        )}
        {ficha.web && (
          <a
            href={ficha.web}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 text-[#1f94c2] font-semibold hover:underline"
          >
            <SvgIcon Icon={Web} className="w-4 h-4" />
            Instagram
          </a>
        )}
      </div>
      {ficha.cursosPendientes && (
        <p className="mt-3 text-xs text-gray-500 text-center">Imágenes de cursos próximamente.</p>
      )}
      {ficha.pagoPendiente && (
        <button
          type="button"
          onClick={avisarPagoPendiente}
          className="mt-4 w-full py-2.5 rounded-xl bg-[#1f94c2] text-white text-sm font-semibold hover:bg-[#1a7ba8]"
        >
          Pagar
        </button>
      )}
    </article>
  );
};

export default AliadoFicha;
